import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import notificationActions from '../actions/notificationActionCreators';
import { Col } from 'react-bootstrap';
import { notificationSorter } from '../utils/sorting';

import Notification from './Notification';
import DeletionModal from './DeletionModal';

require.ensure([], () => {  
    require('./Material-Design-Iconic.less');
    require('./Notifications.less');
});

class Notifications extends React.Component {

    constructor(props, context) {
        super(props, context);
        
        // if we have an existing session don't overwrite
        if (!sessionStorage.getItem("notificationStack"))
            sessionStorage.setItem("notificationStack", JSON.stringify([]));
        this.state = {
            deletedNum: JSON.parse(sessionStorage.getItem("notificationStack")).length,
            deletionModalClosed: true
        };
    }

    // LIFECYCLE METHODS

    componentWillReceiveProps = (nextProps) => {
        this.setState({
            numberOfUnreadNotifications: nextProps.numberOfUnreadNotifications
        })
    }

    componentDidMount = () => {
        this.loadNotificationPage(this.props.numberOfNotificationsToLoad);
    }

    // EVENT HANDLERS

    handleCloseDeletionModal = () => {
        this.setState({
            deletionModalClosed: true
        });
    }
    
    handleOpenDeletionModal = () => {
        this.setState({
            deletionModalClosed: false
        });
    }

    // OTHER METHODS

    deleteNotification = (key) => {
        let notification = this.props.allNotifications[key];

        this.props.dispatch(notificationActions.markAsRead(notification.id));
        this.props.dispatch(notificationActions.delete(notification.id));

        this.setState({
            deletedNum: this.state.deletedNum + 1
        });

        let notificationStack = JSON.parse(sessionStorage.getItem("notificationStack"));
        notificationStack.push(notification);
        sessionStorage.setItem("notificationStack", JSON.stringify(notificationStack));
    }

    deleteAll = () => {
        this.props.dispatch(notificationActions.deleteAll());
        this.setState({
            numberOfUnreadNotifications: 0
        });
        sessionStorage.setItem("notificationStack", JSON.stringify([]));
    }

    markAllAsRead = () => {
        let notificationStack = JSON.parse(sessionStorage.getItem("notificationStack"));

        for (let i = 0; i < notificationStack.length; ++i) {
            notificationStack[i].read = true;
        }

        sessionStorage.setItem("notificationStack", JSON.stringify(notificationStack));
        this.props.dispatch(notificationActions.markAllAsRead());
    }

    loadNotificationPage (numberOfNotificationsToLoad) {
        this.props.dispatch(notificationActions.loadPage(numberOfNotificationsToLoad));;
    }

    markAsRead = (key) => {
        this.props.dispatch(notificationActions.markAsRead(this.props.allNotifications[key].id));
    }

    markAsUnread = (key) => {
        this.props.dispatch(notificationActions.markAsUnread(this.props.allNotifications[key].id));
    }

    undoNotification = () => {
        this.setState({
            deletedNum: this.state.deletedNum - 1
        });
        let notificationStack = JSON.parse(sessionStorage.getItem("notificationStack"));
        let notification = notificationStack.pop();
        sessionStorage.setItem("notificationStack", JSON.stringify(notificationStack));
        this.props.dispatch(notificationActions.undelete(notification.id));
    }

    // RENDER METHOD

    render = () => {
        let hasNondeletedNotifcations = false;

        for (let i = 0; i < this.props.allNotifications.length; i++) {
            if (!this.props.allNotifications[i].deleted) {
                hasNondeletedNotifcations = true;
                break;
            }
        }

        let deletionModal = <DeletionModal handleClose={this.handleCloseDeletionModal} handleSubmit={this.deleteAll} />;

        return (
            <div>
                { !this.state.deletionModalClosed ? deletionModal : null }
                <div className="row" style={{"marginTop": "20px"}}>
                    <Col lg={6} lgOffset={3} md={10} mdOffset={1} sm={12}>
                        <div className="panel panel-default notifications-home">
                            <div className="panel-heading">
                                <div className="panel-title">
                                    <h4 title="Important messages. Mail with unread messages is sent daily.">
                                        My Notifications
                                        <div>
                                            {  this.state.numberOfUnreadNotifications > 0
                                                 ? <a className="icon-btn" onClick={this.markAllAsRead}><span><span title="Mark all as read" className="md-done-all"/></span></a>
                                                 : null
                                            }
                                            {  this.state.deletedNum > 0
                                                 ? <a className="icon-btn" onClick={this.undoNotification}><span title="Restore" className="md-undo"/></a>
                                                 : null
                                            }
                                            {  hasNondeletedNotifcations == true
                                                 ? <a title="Delete" className="icon-btn"><span onClick={this.handleOpenDeletionModal}><span className="md-delete"/></span></a>
                                                 : null
                                            }
                                        </div>
                                    </h4>
                                </div>
                            </div>
                            <div className="notifications-new">
                                <div className="panel-body">
                                    {  hasNondeletedNotifcations
                                         ?
                                         <div className="scrollable-div">
                                             <ul>
                                             {  this.props.allNotifications.map((notification, i) => {
                                                  return <Notification
                                                              deleteNotification={this.deleteNotification}
                                                              id={i}
                                                              key={i}
                                                              markAsRead={this.markAsRead}
                                                              markAsUnread={this.markAsUnread}
                                                              notification={notification}
                                                              />;
                                                })
                                             }
                                             </ul>
                                         </div>
                                         :
                                         <div className="scrollable-div">
                                            <br/>
                                            <h4 style={{textTransform : "none"}} className="text-center">
                                                There are no notifications
                                            </h4>
                                            <br/>
                                         </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </Col>
                </div>
            </div>
        );
    }
}

Notifications.propTypes = {
    allNotifications: PropTypes.array,
    children: PropTypes.element,
    dispatch: PropTypes.func,
    numberOfNotificationsToLoad: PropTypes.number,
    numberOfUnreadNotifications: PropTypes.number
};

const mapStateToProps = (state) => {
        let allNotifications = [];
        let i;

        // backend gives us oldest notifications first so we reverse
        // to get the newest on top
        for (i = state.notifications.notifications.length - 1; i >= 0; --i) {
            allNotifications.push(state.notifications.notifications[i]);
        }

        allNotifications.sort(notificationSorter);

    return {
        allNotifications: allNotifications,
        numberOfNotificationsToLoad: state.notifications.numberOfNotificationsToLoad,
        numberOfUnreadNotifications: state.notifications.numberOfUnreadNotifications
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Notifications);



/** WEBPACK FOOTER **
 ** ./src/app/components/Notifications.js
 **/